import { JSX } from 'react';
import './style.scss';
import { TrafficSituationTagColor } from './tag-color.enum';

function getBgColorClassTrafficSituationTagColorClass(color: TrafficSituationTagColor): string {
  switch (color) {
    case TrafficSituationTagColor.Labs:
      return 'traffic-situation-tag--labs';
    case TrafficSituationTagColor.Blue:
    default:
      return '';
  }
}

export default function TrafficSituationTag({ text, color = TrafficSituationTagColor.Blue }: { text: string; color?: TrafficSituationTagColor }): JSX.Element {
  return <div className={`traffic-situation-tag text-center d-flex align-items-center rounded ${getBgColorClassTrafficSituationTagColorClass(color)}`.trimEnd()}>{text.toLocaleUpperCase()}</div>;
}
